import { render } from "./MatchRequestView.vue?vue&type=template&id=e0ae13c0"
import script from "./MatchRequestView.vue?vue&type=script&lang=js"
export * from "./MatchRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__